
export default function FormValidation(props) {
  const c_states = {
    valid: 'valid',
    invalid: 'invalid',
    mismatch: 'mismatch'
  };

  const c_actions = {
    addClass(el, classState) {
      el.classList.add(classState);
    },
    removeClass(el, classState) {
      el.classList.remove(classState);
    }
  };

  function getSetAlert(parent, state, isAddingClass) {
    const classAction = isAddingClass ? c_actions.addClass : c_actions.removeClass;
    const curState = `is-${state}`;
    classAction(parent, curState);
    if (state === c_states.valid) {
      return;
    }
    Array.from(parent.getElementsByClassName(`error--${state}`))
      .filter((e) => (e))
      .forEach((alert) => classAction(alert, curState));
  }

  function checkSetConfirmMatch(targetInput) {
    const matchElement = document.getElementById(targetInput.dataset.matchInputId);
    if (matchElement && (matchElement.value !== targetInput.value)) {
      matchElement.setCustomValidity('Inputs do not match');
      targetInput.setCustomValidity('Inputs do not match');
    }
  }

  function findFieldsetParent(targetInput) {
    let parent = targetInput.parentNode;
    const tranverseUpNum = 4;
    for (let i = tranverseUpNum; i--;) {
      const validParent = parent.classList.contains('fieldset') && (parent.classList.contains('input-text') || parent.classList.contains('input-option-set'));
      if (validParent) {
        return parent;
      }
      parent = parent.parentNode;
    }
    return null;
  }

  function checkValidity(input, parent) {
    // set for invalid state
    getSetAlert(parent, c_states.invalid, !input.checkValidity());
    // check for mismatch
    checkSetConfirmMatch(input);
    // set for mismatch state
    getSetAlert(parent, c_states.mismatch, (input.validity.customError && input.validity.valueMissing === false));
    // reset for valid state
    getSetAlert(parent, c_states.valid, input.checkValidity());
  }

  function validateFormElements(elements) {
    Array.from(elements)
      .filter((element) => element.required && !element.disabled)
      .map((element) => {
        element.setCustomValidity('');
        return { targetInput: element, inputParent: findFieldsetParent(element) };
      })
      .filter((obj) => obj.inputParent)
      .forEach((obj) => checkValidity(obj.targetInput, obj.inputParent));
  }

  function formValidationBlurEvent(e) {
    validateFormElements([e.target]);
  }

  function keyUpEventListener(e) {
    if (e.target.validity && e.target.validity.customError) {
      validateFormElements([e.target]);
    }
  }

  function customFormSubmitEvent(e) {
    if (!e.target.checkValidity()) {
      e.preventDefault();
      validateFormElements(e.target.elements);
    }
  }

  function Init(form) {
    if (form.tagName.toLowerCase() === 'form') {
      form.setAttribute('novalidate', true);
      form.addEventListener('blur', formValidationBlurEvent, true);
      form.addEventListener('submit', customFormSubmitEvent);
      form.addEventListener('keyup', keyUpEventListener, false);
    }
  }

  Init(props.el);
}
